import { type RouteRecordRaw } from 'vue-router';

export enum MODULE_ROUTE {
  payment = 'PricingMonthlyPayment',
}

export const routes: RouteRecordRaw[] = [
  {
    path: '/:lang?/pricing/monthly/payment/',
    component: () => import('@/modules/monthly/layout/LayoutPage.vue'),
    children: [
      {
        path: '',
        name: MODULE_ROUTE.payment,
        component: () =>
          import('@/modules/monthly/pages/payment/PagePayment.vue'),
        meta: {
          i18nAlias: 'pricing',
        },
      },
    ],
  },
];
